import { render, staticRenderFns } from "./editupt.vue?vue&type=template&id=f6255230&"
import script from "./editupt.vue?vue&type=script&lang=js&"
export * from "./editupt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports